<template>
  <div style="height: calc(100% - 4.5rem)">
    <v-row no-gutters class="d-flex" style="flex-direction: column; height: 100%" align="center" justify="center">
      <span class="connecting-text">{{ $vuetify.locale.t('$vuetify.__InitialLoading.connecting') }}</span>
      <v-progress-circular :size="48" :color="config.main_color" indeterminate></v-progress-circular>
    </v-row>
  </div>
</template>

<script setup>
// global config
import global_config from '@/../config.json'
import { ref } from 'vue'

const config = ref(global_config)
</script>

<style scope>
.connecting-text {
  margin-bottom: 0.875rem;
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 0.875rem;
  color: #3c3c3c;
}
</style>
